module.exports = __webpack_public_path__ + "img/company_logo_whit_white_text.5c497732.png";